import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import iView from "iview";
import "iview/dist/styles/iview.css";
import i18n from "./i18n";

import * as echarts from "echarts";

Vue.use(iView);
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

new Vue({
  router: router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
